import { initializeApp } from 'firebase/app';
import {
    getFirestore,
    initializeFirestore,
    CACHE_SIZE_UNLIMITED
} from 'firebase/firestore';
import {
    getAuth,
    setPersistence,
    browserLocalPersistence
} from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyA6dKE-b_6KJHTyyxaT688ojbvunSh9urM",
    authDomain: "luca-dffcd.firebaseapp.com",
    projectId: "luca-dffcd",
    storageBucket: "luca-dffcd.firebasestorage.app",
    messagingSenderId: "33933650326",
    appId: "1:33933650326:web:84e2594909d942533555b7",
    measurementId: "G-W9J2FDXQV5"
};

// Initialize Firebase
let app;
let db: any;
let auth: any;
let storage: any;
let functions: any;

try {
    console.log('[Firebase] Starting initialization...');

    // Detect if running in Capacitor/APK
    const isCapacitor = typeof (window as any).Capacitor !== 'undefined';
    console.log('[Firebase] Platform detected:', isCapacitor ? 'Capacitor/APK' : 'Web');

    app = initializeApp(firebaseConfig);
    console.log('[Firebase] App initialized');

    // Initialize Firestore with fallback for APK
    if (isCapacitor) {
        console.log('[Firebase] APK detected - attempting long polling initialization');
        try {
            // Try to initialize with APK-specific settings
            db = initializeFirestore(app, {
                cacheSizeBytes: CACHE_SIZE_UNLIMITED,
                experimentalForceLongPolling: true,
                experimentalAutoDetectLongPolling: true,
                ignoreUndefinedProperties: true
            });
            console.log('[Firebase] ✅ Firestore initialized with long polling (APK mode)');
        } catch (firestoreError) {
            console.warn('[Firebase] ⚠️ Long polling init failed, using standard Firestore:', firestoreError);
            // Fallback to standard initialization
            db = getFirestore(app);
            console.log('[Firebase] Firestore initialized with standard settings (fallback)');
        }
    } else {
        console.log('[Firebase] Web mode - using standard Firestore');
        db = getFirestore(app);
    }

    console.log('[Firebase] Initializing Auth, Storage, and Functions...');
    auth = getAuth(app);
    storage = getStorage(app);
    functions = getFunctions(app);

    // Set persistence to LOCAL to keep user logged in across page reloads
    console.log('[Firebase] Setting auth persistence...');
    setPersistence(auth, browserLocalPersistence).catch((error) => {
        console.error('[Firebase] Failed to set auth persistence:', error);
    });

    console.log('[Firebase] ✅ Initialization complete!');
    console.log('[Firebase] DB ready:', !!db, '| Auth ready:', !!auth, '| Storage ready:', !!storage);
} catch (error) {
    console.error('[Firebase] ❌ CRITICAL initialization error:', error);
    console.error('[Firebase] Error details:', error instanceof Error ? error.message : String(error));

    // Don't throw - try to recover with basic initialization
    console.log('[Firebase] Attempting emergency fallback initialization...');
    try {
        if (!app) {
            app = initializeApp(firebaseConfig);
        }
        if (!db) {
            db = getFirestore(app);
        }
        if (!auth) {
            auth = getAuth(app);
        }
        if (!storage) {
            storage = getStorage(app);
        }
        if (!functions) {
            functions = getFunctions(app);
        }
        console.log('[Firebase] ⚠️ Emergency fallback successful');
    } catch (fallbackError) {
        console.error('[Firebase] ❌ Emergency fallback also failed:', fallbackError);
        throw error; // Now throw the original error
    }
}

export { app, db, auth, storage, functions };
